import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as GameHistoryActions from './game-history.actions';
import * as GameHistoryFeature from './game-history.reducer';
import * as GameHistorySelectors from './game-history.selectors';
@Injectable()
export class GameHistoryFacade {
  gameHistory$ = this.store.pipe(
    select(GameHistorySelectors.getAllGameHistory),
  );
  totalGameHistory$ = this.store.pipe(
    select(GameHistorySelectors.getGameHistoryTotal),
  );
  loaded$ = this.store.pipe(select(GameHistorySelectors.getGameHistoryLoaded));

  constructor(private store: Store<GameHistoryFeature.GameHistoryState>) {}

  loadGameHistory(
    options: {
      pageIndex: number;
      pageSize: number;
      forfeited: boolean;
      gameType: string;
      orderBy: string;
      orderDir: string;
    } = {
      forfeited: false,
      gameType: 'CASUAL',
      orderBy: 'createdAt',
      orderDir: 'DESC',
      pageIndex: 0,
      pageSize: 10,
    },
  ) {
    this.store.dispatch(
      GameHistoryActions.loadGameHistory({ params: options }),
    );
  }
}
